import React from 'react'
import { motion } from 'framer-motion'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
export default function LoansLayout() {
    const { pathname, state } = useLocation()
    const { id } = useParams()
    const navigate = useNavigate()
    const isAddButton = pathname.includes('requested-loans')
    return (
        <div className="sm:w-full md:px-[35%] relative md:bg-bg-md-screen">
            <div className=" h-full bg-main-bg">
                <div className=" min-h-screen flex flex-col relative">
                    <motion.div
                        key={pathname}
                        initial={{ opacity: 0, x: '100%' }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: '-100%' }}
                        transition={{ duration: 0.2 }}
                        className=" grow"
                    >
                        <div className="">
                            <Outlet />
                        </div>
                    </motion.div>
                    {isAddButton && (
                        <div className=" cursor-pointer md:right-[37%] fixed bottom-10 right-4 bg-green-1 rounded-lg text-white py-2 px-4 items-center">
                            <p
                                className=" items-center"
                                onClick={() =>
                                    // The wizard reads the caller's own
                                    // membership from `?poolship=` rather than
                                    // router state: this link is also the one
                                    // people bookmark and reload, and router
                                    // state does not survive that — which is
                                    // how the old form ended up asking for a
                                    // bank card it could not look up.
                                    navigate(
                                        `/loans/request/${id}?poolship=${
                                            state?.poolShipId ?? ''
                                        }`,
                                        {
                                            state: {
                                                poolShipId: state?.poolShipId,
                                            },
                                        }
                                    )
                                }
                            >
                                ثبت درخواست <span className=" text-xl">+</span>
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
